/**
 * @Description 机会点详情-商圈信息详情
 *
 * 需要读取匹配商圈属性的 templateRestriction
"{\"modelId\":18,\"modelCode\":\"kwk_milk_tea_model_000\",\"modelName\":\"卡旺卡\"}"
 */
import { FC, useMemo } from 'react';
import { Row, Col } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
// import BusinessOverview from './BusinessOverview';
import AreaOverview from './AreaOverview';
import SpotEvaluationOverview from './SpotEvaluationOverview';

const BusinessInfoDetail: FC<any> = ({
  propertyItem,
  info = {},
  detailInfoConfig = { span: 12 },
  disabledArea
}) => {
  const modelId = useMemo(() => {
    if (!propertyItem?.restriction) {
      return null;
    }
    const restriction = JSON.parse(propertyItem.restriction);
    return restriction?.modelId;
  }, [propertyItem]);

  /* method */

  if (!info) {
    // 未选择地址
    return (<Row gutter={24}>
      <Col {...detailInfoConfig}>
        <V2DetailItem label='开店区域' value='选择详细地址后获取'/>
      </Col>
    </Row>);
  } else if (!info.isInCluster) {
    // 不处于任何开店区域内，显示周边点位测评信息
    return (
      <SpotEvaluationOverview
        lng={info?.lng}
        lat={info?.lat}
        modelId={modelId}
        isDetailPage={true}
      />
    );
  } else {
    // 处于开店区域内，显示区域信息
    return <AreaOverview
      curCompValue={info}
      modelId={modelId}
      clusterId={info.clusterId}
      isDetailPage={true}
      disabledArea={disabledArea}
    />;
  }
};

export default BusinessInfoDetail;
